module.exports = __webpack_public_path__ + "img/logo.585e2f34.png";